import PageModule from "@eisinc/Overrides/Pages/OrderHistoryPage";

export * from "@eisinc/Overrides/Pages/OrderHistoryPage";

export default PageModule;
